/* eslint-disable prettier/prettier */
import { useCartMutationVariables } from "@/core/api/graphql/cart/composables";
import { useMutation } from "@/core/api/graphql/composables";
import { UpdateCartItemDynamicPropertiesDocument } from "@/core/api/graphql/types";
import type { CartIdFragment } from "@/core/api/graphql/types";
import type { MaybeRef } from "vue";

export function useUpdateCartItemDynamicPropertiesMutation(cart?: MaybeRef<CartIdFragment | undefined>) 
{
    return useMutation(UpdateCartItemDynamicPropertiesDocument, useCartMutationVariables(cart));
}